import { Suspense, useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { isUserAuthenticated, Login, ResetPasswordPage } from '~/auth';
import AzureRedirect from '~/auth/azure';
import { NotifyAdminModal } from '~/components/Modals';
import { UserInfoContext } from '~/context/user';
import { getRoutes, routesEnum } from '~/routes';
import { FlexLayout, LoadingSpinner, useDocumentTitle } from '~/ui';

function PrivateRoute({ component: Component, roles }) {
  const { userInfo } = useContext(UserInfoContext);

  if (!userInfo) {
    return <LoadingSpinner />;
  }

  if (roles && !roles.includes(userInfo.role)) {
    return <Navigate to={routesEnum.DASHBOARD} replace />;
  }

  if (!isUserAuthenticated()) {
    return <Navigate to={routesEnum.LOGIN} replace />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  );
}

function ContentWindow() {
  useDocumentTitle();
  const { userInfo } = useContext(UserInfoContext);

  const clientModules = userInfo?.client?.clientFeatures.filter((cl) => cl.feature.isModule);
  const clientRoutes = getRoutes(clientModules);

  return (
    <FlexLayout flexGrow="1">
      <Routes>
        <Route path={routesEnum.LOGIN} element={<Login />} />
        <Route path={routesEnum.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route path={routesEnum.AZURE_REDIRECT} element={<AzureRedirect />} />

        {Object.values(clientRoutes).map(({ component, path, roles }) => (
          <Route key={path} path={path} element={<PrivateRoute component={component} roles={roles} />} />
        ))}
        <Route path="*" element={<Navigate to={routesEnum.DASHBOARD} replace />} />
      </Routes>
      <NotifyAdminModal />
    </FlexLayout>
  );
}

export default ContentWindow;
